import { render, staticRenderFns } from "./JustificationReasonPopup.vue?vue&type=template&id=3e137a16&"
import script from "./JustificationReasonPopup.vue?vue&type=script&lang=ts&"
export * from "./JustificationReasonPopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports